webpackJsonp([263791100135453],{

/***/ 251:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(29);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Footer = __webpack_require__(46);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(47);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _pageModule = __webpack_require__(53);
	
	var _pageModule2 = _interopRequireDefault(_pageModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  return Glamor.createElement(
	    "div",
	    { className: _pageModule2.default.flex },
	    Glamor.createElement(_Header2.default, { color: "black" }),
	    Glamor.createElement(
	      "div",
	      { className: _pageModule2.default.page },
	      Glamor.createElement(
	        "div",
	        null,
	        Glamor.createElement(
	          "h1",
	          null,
	          "Hello from Yvette"
	        ),
	        Glamor.createElement("img", { src: '../static/photos/hello.jpg' }),
	        Glamor.createElement(
	          "div",
	          null,
	          Glamor.createElement(
	            "p",
	            null,
	            "Hi, thank you for visiting my website!"
	          ),
	          Glamor.createElement(
	            "p",
	            null,
	            "In 2016 I received my Master's degree in Mechanical Engineering. After working one year as a PV solar engineer, I decided to make a transition to a field that would challenge me and aligns more closely with my interests."
	          ),
	          Glamor.createElement(
	            "p",
	            null,
	            "As I've always been interested in coding, I made my mind to become a full stack engineer."
	          ),
	          Glamor.createElement(
	            "p",
	            null,
	            "I enjoy engineering challenges in web development. When I have free time I dance and play the guitar."
	          ),
	          Glamor.createElement("br", null),
	          Glamor.createElement(
	            "p",
	            null,
	            "Proficient: Javascript, React, Redux, React-Native, Git, Node.js, Express, Sequelize, PostgreSQL, Axios, HTML, CSS"
	          ),
	          Glamor.createElement(
	            "p",
	            null,
	            "Knowledgeable: R, Python, MySQL, Gatsby.js, GraphQL"
	          )
	        )
	      )
	    ),
	    Glamor.createElement(_Footer2.default, { color: "black" })
	  );
	};
	
	module.exports = exports["default"];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(9)))

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"flex":"src-pages----page-module---flex---HxH_T","page":"src-pages----page-module---page---vIddo","projectPage":"src-pages----page-module---projectPage---3Y-MS","projectPageTitle":"src-pages----page-module---projectPageTitle---2znlH","blogSpan":"src-pages----page-module---blogSpan---1wSvu","blogPosts":"src-pages----page-module---blogPosts---2e0Mn","projectContainer":"src-pages----page-module---projectContainer---Akwbh"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-08779121cad9b06e5f57.js